"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrenchFormWithSpanSubFormGenerator = void 0;
const tslib_1 = require("tslib");
const __1 = require("../..");
const TestDataGenerator_1 = require("./TestDataGenerator");
const BaseFormFactory_1 = require("../pole/BaseFormFactory");
/**
 * Creates a Form which uses the Span SubForm feature with French field names and span type options.
 */
class FrenchFormWithSpanSubFormGenerator extends TestDataGenerator_1.TestDataGenerator {
    configureForm(form) {
        const factory = new BaseFormFactory_1.BaseFormFactory(form);
        factory.addBaseFormFields();
        factory.rootPoleSubForm();
        // Change the span field name to be French.
        factory.baseForm.spanField.Mutator.displayName('Portée');
    }
    createPoleForm(form) {
        return new __1.BaseForm(form);
    }
    createCollection(loader, location) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            loader.addForm(__1.IkeModel.Form.write(this.form));
            const collection = new __1.CollectionModel(this.form, loader);
            const revision = __1.IkeId.generate();
            collection.state.id = revision;
            collection.state.uuid = revision;
            collection.state.revision = revision;
            const loc = __1.IkeGeodesic.projectLocation(location, Math.PI, 20);
            collection.getField(__1.PoleFieldIds.GEOGRAPHIC_COORDINATE).Mutator.manual(loc);
            return collection;
        });
    }
    createCollectionWithSpan(loader, location, spanType, spanVector) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const collection = yield this.createCollection(loader, location);
            const pole = new __1.PoleCollectionAdaptor(collection, this.poleForm);
            const foreSpan = new __1.SpanSubFormAdaptor(pole.spanField.getInstance(pole.spanField.Mutator.create()));
            foreSpan.spanTypeField.Mutator.manual(spanType);
            foreSpan.spanVectorField.Mutator.manual(spanVector);
            loader.addCollection(yield __1.IkeModel.Collection.write(collection));
            return collection;
        });
    }
}
exports.FrenchFormWithSpanSubFormGenerator = FrenchFormWithSpanSubFormGenerator;
//# sourceMappingURL=FrenchFormWithSpanSubFormGenerator.js.map